/**
 * 获取完整的图片URL
 * @param {string} path - 图片相对路径
 * @returns {string} 完整的图片URL
 */
export function getImageUrl(path) {
  // 确保path不以/开头
  if (path.startsWith("/")) {
    path = path.substring(1);
  }

  return window.phConfig.IMG_BASE_API + path;
}
